import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  replaceStoreSuccess,
  setCategories,
  startLoading,
  stopLoading,
} from "./Actions";
import { toast } from "react-toastify";
import {
  saveStore,
  getStore,
  saveProduct as updateProduct,
  saveProducts as updateProducts,
  api,
} from "../../../Services/Api";

function* refreshStore() {
  yield put(startLoading());
  try {
    const response = yield call(getStore);

    yield put(replaceStoreSuccess(response));
  } catch (err) {
    yield put(stopLoading());
    toast.error("Erro ao salvar!");
  }
}

function* replaceStore({ store }) {
  try {
    const response = yield call(saveStore, store);
    toast.success("Salvo com sucesso!");
    yield put(replaceStoreSuccess(response));
  } catch (err) {
    toast.error("Erro ao salvar!");
  }
}

function* saveNeighborhoods({ neighborhoods }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        neighborhoodsPrice: neighborhoods,
      };
    });
    yield call(
      api.put,
      "/service/neighborhoods",
      neighborhoods.map((neigh) => ({
        ...neigh,
        deliveryPrice: Number(neigh.deliveryPrice),
      }))
    );
    toast.success("Salvo com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao salvar!");
  }
}

function* openStore() {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        is_active: true,
      };
    });
    yield call(api.put, "/establishment/open");
    toast.success("O Estabelecimento foi Aberto");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao abrir!");
  }
}

function* saveDeliveryTime({ deliveryTime }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        deliveryTime: deliveryTime,
      };
    });
    yield call(api.put, "/service/delivery-time", {
      enabled: deliveryTime.enabled,
      from: deliveryTime.time.from,
      to: deliveryTime.time.to,
    });
    toast.success("Tempo de entrega alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar tempo de entrega!");
  }
}

function* closeStore() {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        is_active: false,
      };
    });
    yield call(api.put, "/establishment/close");
    toast.success("O Estabelecimento foi Fechado");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao fechar!");
  }
}

function* updateDeliveryCalcMethod({ method }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        deliveryCalcMethod: method,
      };
    });
    yield call(api.put, "/service/delivery-calc-method", { method: method });
    toast.success("Alterado método de cobrança!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar método de cobrança!");
  }
}

function* updateDeliveryFee({ deliveryFee }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        deliveryFee: deliveryFee,
        deliveryCalcMethod: "fixed",
      };
    });
    yield call(api.put, "/service/fixed-price", { price: deliveryFee });
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao salvar!");
  }
}

function* saveDeliveryEnabled({ isEnabled }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        deliveryEnabled: isEnabled,
      };
    });
    yield call(api.put, "/service/delivery-type", {
      deliveryEnabled: isEnabled,
      takeawayEnabled: storeUpdated.takeawayEnabled,
    });
    toast.success("Tipo de entrega alterado");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar tipo de entrega!");
  }
}

function* saveTakeawayEnabled({ isEnabled }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        takeawayEnabled: isEnabled,
      };
    });
    yield call(api.put, "/service/delivery-type", {
      takeawayEnabled: isEnabled,
      deliveryEnabled: storeUpdated.deliveryEnabled,
    });
    toast.success("Tipo de entrega alterado");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar tipo de entrega!");
  }
}

function* saveEstablishmentConfig({ config }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        name: config.name,
        city: config.city,
      };
    });
    yield call(api.put, "/establishment/config", config);
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar!");
  }
}

function* saveServiceBasicConfig({ whatsapp, alias }) {
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        whatsapp: whatsapp,
        alias: alias,
      };
    });
    yield call(api.put, "/service/config", { whatsapp, alias });
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar!");
  }
}

function* updatePaymentMethods({ methods }) {
  yield put(startLoading());
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        paymentMethods: methods,
      };
    });
    yield call(api.put, "/service/payment-methods", { methods });
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar!");
  } finally {
    yield put(stopLoading());
  }
}

function* updateAddress({ address }) {
  yield put(startLoading());
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        address: address,
      };
    });
    yield call(api.put, "/establishment/address", address);
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar!");
  } finally {
    yield put(stopLoading());
  }
}

function* updateTemplate({ template }) {
  yield put(startLoading());
  try {
    const storeUpdated = yield select((state) => {
      return {
        ...state.store,
        template: template,
      };
    });
    yield call(api.put, "/establishment/template", template);
    toast.success("Alterado com sucesso!");
    yield put(replaceStoreSuccess(storeUpdated));
  } catch (err) {
    toast.error("Erro ao alterar!");
  } finally {
    yield put(stopLoading());
  }
}

export default all([
  takeLatest("REPLACE_STORE_REQUEST", replaceStore),
  takeLatest("GET_STORE_REQUEST", refreshStore),
  takeLatest("SAVE_NEIGHBORHOODS", saveNeighborhoods),
  takeLatest("UPDATE_DELIVERY_CALC_METHOD", updateDeliveryCalcMethod),
  takeLatest("UPDATE_DELIVERY_FEE", updateDeliveryFee),
  takeLatest("OPEN_STORE", openStore),
  takeLatest("CLOSE_STORE", closeStore),
  takeLatest("SAVE_DELIVERY_TIME", saveDeliveryTime),
  takeLatest("SAVE_DELIVERY_ENABLED", saveDeliveryEnabled),
  takeLatest("SAVE_TAKEAWAY_ENABLED", saveTakeawayEnabled),
  takeLatest("SAVE_ESTABLISHMENT_CONFIG", saveEstablishmentConfig),
  takeLatest("SAVE_SERVICE_BASIC_CONFIG", saveServiceBasicConfig),
  takeLatest("UPDATE_PAYMENT_METHODS", updatePaymentMethods),
  takeLatest("UPDATE_ADDRESS", updateAddress),
  takeLatest("UPDATE_TEMPLATE", updateTemplate),
]);
